<template>
  <div class="section">
    <navigation tabindex="0" />
    <div style="height: 80px; width: 100%"></div>
    <div class="user">
      <div class="user-c">
        <h2>注册</h2>
        <div class="userinput" style="margin-bottom: 20px">
          <input
            type="text"
            placeholder="请输入用户名"
            ref="userName"
            @blur="userNameBlur"
          />
        </div>
        <div class="userinput userinputphone" style="margin-bottom: 20px">
          <input
            type="text"
            placeholder="请输入手机号"
            ref="phoneNumber"
            @blur="phoneNumberBlur"
          />
        </div>

        <div class="yzminput" style="margin-bottom: 20px">
          <div class="userinput userinputyzm">
            <input
              type="text"
              placeholder="请输入验证码"
              ref="phoneCode"
              style="width: 130px"
            />
          </div>
          <div
            class="getcode"
            :style="btnDisabled == true ? 'background:#999999' : ''"
            @click="sendMessage"
          >
            {{ btnText }}
          </div>
        </div>
        <div class="userinput userinputpsd" style="margin-bottom: 20px">
          <input
            type="password"
            v-model="pwd"
            placeholder="请输入密码，密码长度8~18位"
            ref="pwd"
            @blur="pwdBlur"
          />
        </div>
        <div class="userinput userinputpsd" style="margin-top: 10px">
          <input
            type="password"
            placeholder="请再次输入密码"
            ref="pwdAgain"
            @blur="pwdAgainBlur"
          />
        </div>
        <!-- 清除浮动 -->
        <div style="clear: both"></div>
        <div class="agreement">
          <div
            v-show="agreement == 2"
            @click="agreementFn(1)"
            style="
              width: 15px;
              height: 15px;
              margin-right: 10px;
              float: left;
              cursor: pointer;
            "
          >
            <img
              src="../../static/login/i7.png"
              alt=""
              style="display: block; width: 100%; height: 100%"
            />
          </div>
          <div
            v-show="agreement == 1"
            @click="agreementFn(2)"
            style="
              width: 15px;
              height: 15px;
              margin-right: 10px;
              float: left;
              cursor: pointer;
            "
          >
            <img
              src="../../static/login/i6.png"
              alt=""
              style="display: block; width: 100%; height: 100%"
            />
          </div>
          <span style="font-size: 12px; color: #999999"
            >我已认真阅读并同意</span
          >
          <span
            @click="goRead()"
            style="color: #3476c1; font-size: 12px; cursor: pointer"
            >《用户注册协议》</span
          >
        </div>
        <div class="go" @click="goFn()">立即注册</div>
        <div class="gologin">
          已有账号，<span @click="$router.push({ name: 'login' })"
            >马上登录</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { testFn } from "@/utils/validate";
import navigation from "../../components/common/navigation.vue";
export default {
  name: "register",
  components: {
    navigation,
  },
  data() {
    return {
      isShow: false, //手机号提示信息
      isConfirm: false, //密码确认
      isChecked: true,
      radio: "0", //身份单选按钮
      sex: "0", //性别
      model6: "",
      model7: "",
      model8: "",
      gradeList: [],
      errortext: "", //提示错误信息
      userNameCheck: true,
      phoneNumberCheck: true,
      pwdCheck: true,
      pwdAgainCheck: true,
      pwd: "",
      identityNumberCheck: true, //身份证号
      teacherCodeCheck: true, //教师编号
      emailCheck: true, //邮箱

      btnDisabled: false,
      btnText: "发送验证码",
      agreement: 1,
    };
  },
  methods: {
    userNameBlur() {
      let userName = this.$refs.userName.value;
      //判断用户名是否存在
      // this.$axios.get("/v1/muke/student/user/decideaAccount?account="+userName)
      // .then(({data})=>{
      //     if(data.data == 1){
      //         this.userNameCheck = false;
      //         this.errortext = '用户名已存在';
      //     }else{
      //         this.userNameCheck = true;
      //         this.errortext = '';
      //     }
      // })
    },
    realUserNameBlur() {},
    phoneNumberBlur() {
      //判断手机号是否存在
      let phoneNumber = this.$refs.phoneNumber.value;
      if (!/^1[3|4|5|7|8|9][0-9]\d{4,8}$/.test(this.$refs.phoneNumber.value)) {
        this.phoneNumberCheck = false;
        this.errortext = "请输入正确手机号";
      } else {
        this.phoneNumberCheck = true;
        this.errortext = "";
      }
      // this.$axios.get("/v1/muke/student/user/decideaMobile?mobile="+phoneNumber)
      // .then(({data})=>{
      //     if(data.data == 1){
      //         this.phoneNumberCheck = false;
      //         this.errortext = '手机号已存在';
      //     }else if(!/^1[3|4|5|7|8|9][0-9]\d{4,8}$/.test(this.$refs.phoneNumber.value)){
      //         this.phoneNumberCheck = false;
      //         this.errortext = '请输入正确手机号';
      //     }else{
      //         this.phoneNumberCheck = true;
      //         this.errortext = '';
      //     }
      // })
    },
    getCode() {
      // let phoneNumber = this.$refs.phoneNumber.value;
      // if(!/^1[3|4|5|7|8|9][0-9]\d{4,8}$/.test(phoneNumber)){
      //     this.$Message.warning('请输入正确手机号！');
      // }else{
      //     this.$axios.get("/v1/muke/student/user/sendCode?mobile="+phoneNumber)
      //     .then(({data})=>{
      //         if(data.data == 1){
      //             this.$Message.success('发送验证码成功！');
      //         }else if(data.data === 0){
      //             this.$Message.error(data.message);
      //         }else{
      //             this.$Message.success('验证码发送发送失败！');
      //         }
      //     })
      // }
    },
    sendMessage() {
      if (this.btnDisabled) {
        return;
      }
      let phoneNumber = this.$refs.phoneNumber.value;
      if (!/^1[3|4|5|7|8|9][0-9]\d{4,8}$/.test(phoneNumber)) {
        this.$Message.warning("请输入正确手机号！");
      } else {
        this.$axios
          .get("/v1/cloud/common/sendCode?phoneNum=" + phoneNumber)
          .then(({ data }) => {
            if (data) {
              this.$Message.success("发送验证码成功！");
              this.getSecond(30);
            }
          })
          .catch((error) => {
            this.$message({
              message: error.response.data.message,
              type: "warning",
            });
          });
      }
    },
    //发送验证码
    getSecond(wait) {
      let _this = this;
      let _wait = wait;
      if (wait == 0) {
        this.btnDisabled = false;
        this.btnText = "获取验证码";
        wait = _wait;
      } else {
        this.btnDisabled = true;
        // this.btnText="验证码(" + wait + "s)"
        this.btnText = "" + wait + " s重新获取";
        wait--;
        setTimeout(function () {
          _this.getSecond(wait);
        }, 1000);
      }
    },

    pwdBlur() {
      if (this.$refs.pwd.value != "") {
        if (!/^[a-zA-Z0-9_]{8,18}$/.test(this.$refs.pwd.value)) {
          this.pwdCheck = false;
          this.errortext = "密码长度只能在8-18位之间";
        } else {
          this.pwdCheck = true;
          this.errortext = "";
        }
      }
    },
    pwdAgainBlur() {
      if (this.$refs.pwdAgain.value != "") {
        if (this.$refs.pwdAgain.value != this.pwd) {
          this.pwdAgainCheck = false;
          this.errortext = "两次密码输入不一致";
        } else {
          this.pwdAgainCheck = true;
          this.errortext = "";
        }
      }
    },
    identityNumberBlur() {
      //判断身份证号是否存在
      let identityNumber = this.$refs.identityNumber.value;
      // this.$axios.get("/v1/muke/student/user/decideaIdCard?idCard="+identityNumber)
      // .then(({data})=>{
      //     if(data.data == 1){
      //         this.identityNumberCheck = false;
      //         this.errortext = '身份证号已存在';
      //     }else if(!/^[a-zA-Z0-9_]{18}$/.test(this.$refs.identityNumber.value)){
      //         this.identityNumberCheck = false;
      //         this.errortext = '身份证号格式错误';
      //     }else{
      //         this.identityNumberCheck = true;
      //         this.errortext = '';
      //     }
      //     console.log("判断身份证号是否存在",data);
      // })
    },
    iteacherCodeBlur() {
      let teacherCode = this.$refs.teacherCode.value;
      //判断用户名是否存在
      // this.$axios.get("/v1/muke/student/user/decideaTeacherCard?teacherCard="+teacherCode)
      // .then(({data})=>{
      //     if(data.data == 1){
      //         this.teacherCodeCheck = false;
      //         this.errortext = '教师编号已存在';
      //     }else{
      //         this.teacherCodeCheck = true;
      //         this.errortext = '';
      //     }
      // })
    },
    emailBlur() {
      //判断邮箱是否存在
      let email = this.$refs.email.value;
      // this.$axios.get("/v1/muke/student/user/decideaEmail?email="+email)
      // .then(({data})=>{
      //     if(data.data == 1){
      //         this.emailCheck = false;
      //         this.errortext = '邮箱已存在';
      //     }else if(!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(this.$refs.email.value)){
      //         this.emailCheck = false;
      //         this.errortext = '邮箱格式错误';
      //     }else{
      //         this.emailCheck = true;
      //         this.errortext = '';
      //     }
      //     console.log("判断邮箱是否存在",data);
      // })
    },
    //机构下拉选择框 数据改变事件
    change() {
      for (var i = 0; i < this.organizationList.length; i++) {
        if (this.organizationList[i].institutionId == this.model6) {
          this.gradeList = this.organizationList[i].gradeList;
        }
      }
    },
    goIndex() {
      localStorage.setItem("tabFlag", 1);

      this.$router.push({ name: "home" });

      // sessionStorage.setItem('tabIndex','1');
    },
    agreementFn(s) {
      this.agreement = s;
    },

    // 跳转到协议页面
    goRead() {
      this.$router.push("/readAgreement");
    },

    goFn() {
      let userName = this.$refs.userName.value;
      let phoneNumber = this.$refs.phoneNumber.value;
      let phoneCode = this.$refs.phoneCode.value;
      let pwd = this.$refs.pwd.value;
      let pwdAgain = this.$refs.pwdAgain.value;

      let param = {
        name: userName,
        phoneNum: phoneNumber,
        validCode: phoneCode, //手机验证码
        pwd,
        confirmPwd: pwdAgain,
      };
      if (!param.name) {
          this.$message.error('请输入用户名')
          return
      }
      if (!param.phoneNum) {
          this.$message.error('请输入手机号')
          return
      }
      if (!param.validCode) {
          this.$message.error('请输入验证码')
          return
      }
      console.log(param);
      if (!param.pwd || param.pwd != param.confirmPwd) {
          this.$message.error('两次密码输入不一致')
          return
      }
      if (this.agreement != 2) {
          this.$message.error('请阅读并同意用户注册协议')
          return
      }
      this.$axios
        .post("/v1/cloud/common/user/sign-up", param, {})
        .then(({ data }) => {
          if (data) {
            this.$message.success('注册成功')
            this.$router.push({ name: "login" });
          } else {
            // this.$Message.error(data.msg);
          }
        })
        .catch((error) => {
          this.$message({
            message: error.response.data.message,
            type: "warning",
          });
        });
    },
    smselectFn() {
      if (this.selectSon === "display:block") {
        this.selectSon = "display:none";
      } else {
        this.selectSon = "display:block";
      }
    },
    selectFn(s) {
      this.smselect = s;
      this.selectSon = "display:none";
    },
    // 手机文本框得焦事件
    hintMssage() {
      this.isShow = !this.isShow;
    },
    //密码文本框实时监控
    changePassword() {
      if (this.$refs.usPassword.value != "") {
        if (/^[a-zA-Z0-9_]{4,16}$/.test(this.$refs.usPassword.value)) {
          this.isError = false;
          //console.log(this.$refs.passwordNum.value);
        }
      }
    },
    //确认密码文本框的实时监控
    reEnterPassword() {
      var confirmNum = this.$refs.confirmNum.value;
      if (confirmNum != "" && this.$refs.usPassword.value === confirmNum) {
        console.log("密码一致");
        this.isConfirm = false;
      }
    },
  },

  created() {},
  mounted() {},
};
</script>

<style scoped lang="less">
a {
  text-decoration: none;
}
li {
  list-style: none;
}
input {
  outline: none;
  border: none;
  background: rgba(0, 0, 0, 0);
}
.section {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;

  background: #fafafa;
  // height:900px;

  .user {
    width: 100%;
    background: #f3f3f3;
    height: 760px;
    overflow: hidden;
    background-image: url("../../static/common/backgroundimg.png");
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    padding-top: 76px;
    box-sizing: border-box;

    .user-c {
      width: 450px;
      height: 563px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
      margin: 0 auto;
      padding: 0 40px;
      box-sizing: border-box;
      input::placeholder {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 40px;
      }
      h2 {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        text-align: center;
        line-height: 94px;
      }
      .getcode {
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #3476c1;
        border-radius: 4px;
        font-size: 12px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
      .yzminput {
        display: flex;
        justify-content: space-between;
        .userinput {
          width: 250px;
        }
      }
      .userinput {
        width: 100%;
        height: 40px;
        border: 1px solid #eeeeee;
        border-radius: 3px;
        padding-left: 36px;
        box-sizing: border-box;
        background-image: url("../../static/common/usericon.png");
        background-size: 18px 18px;
        background-position: 10px 12px;
        background-repeat: no-repeat;
        img {
          display: block;
          float: left;
          width: 18px;
          height: 18px;
          margin-left: 16px;
          margin-top: 8px;
          margin-right: 12px;
        }
        input {
          width: 100%;
          height: 100%;
        }
      }
      .userinputpsd {
        background-image: url("../../static/common/psdicon.png");
        background-position: 10px 11px;
      }
      .userinputphone {
        background-image: url("../../static/common/phoneicon.png");
        background-position: 10px 11px;
      }
      .userinputyzm {
        background-image: url("../../static/common/yzmicon.png");
        background-position: 10px 11px;
      }
      /*iview 选择框组件*/
      .iselect {
        .ivu-select {
          width: 378px !important;
        }
        .ivu-select-selection {
          border-radius: 0px;
          border-color: #bfbfbf;
          height: 34px;
        }
        .ivu-select-single .ivu-select-selection {
          width: 378px;
          margin-top: 7px;
          outline: none;
        }
        .ivu-select-selection-focused,
        .ivu-select-selection:hover {
          border-color: #bfbfbf;
        }
        .ivu-select-item {
          width: 378px;
        }
        .ivu-select-visible .ivu-select-selection {
          border-color: #bfbfbf;
          box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
        }

        .ivu-select-prefix {
          border-radius: 0;
        }
        .ivu-avatar {
          border-radius: 0;
        }
        .ivu-avatar-small {
          width: 18px;
          height: 18px;
          margin-left: 16px;
          margin-right: 12px;
        }
        .ivu-select-single .ivu-select-prefix {
          padding-left: 0px;
        }
      }

      .smselect {
        input {
          outline: none;
        }
        .ivu-select-prefix {
          border-radius: 0;
        }
        .ivu-avatar {
          border-radius: 0;
        }
      }

      .identity {
        overflow: hidden;
        width: 100%;
        height: 36px;
        line-height: 36px;
        margin-top: 7px;
        .el-radio__input.is-checked + .el-radio__label {
          color: #a7a7a7;
        }
        .el-radio__label {
          padding-left: 4px;
        }
        .el-radio {
          margin-right: 12px;
        }
        .el-radio__inner {
          width: 11px;
          height: 11px;
        }
        .el-radio__inner::after {
          background-color: #707070;
          width: 5px;
          height: 5px;
        }
        .el-radio__input.is-checked .el-radio__inner {
          border-color: #bdbdbd;
          background: #dddddd;
        }
      }
      .go {
        margin-top: 39px;
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #3476c1;
        border-radius: 4px;
        cursor: pointer;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        box-sizing: border-box;
      }

      .gologin {
        margin-top: 20px;
        margin-bottom: 16px;
        font-size: 12px;
        height: 12px;
        line-height: 12px;
        color: #8b8b8c;
        span {
          cursor: pointer;
          color: #3476c1;
          font-size: 12px;
        }
      }
      .errortext {
        width: 100%;
        height: 15px;
        line-height: 15px;
        margin: 8px 0px;
        color: #df0000;
      }
      .agreement {
        height: 15px;
        line-height: 15px;
        width: 280px;
        margin-top: 17px;
        // margin:0 auto;
      }
    }
  }
  .go-home {
    width: 430px;
    margin: 0 auto;
    height: 12px;
    line-height: 12px;
    margin-top: 20px;
    text-align: right;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    cursor: pointer;
  }
  .go-home:hover {
    color: #3476c1;
  }
}
</style>